import getEnabledItems from '@lyearn/core/utils/array/getEnabledItems';
import { TFunction } from '@lyearn/i18n';
import { BookOpenOutline, MessageSquare2Outline, PeopleOutline, TvOutline } from '@lyearn/icons';
import { TabType } from '@lyearn/ui';
import dynamic from '@/utils/dynamic';

export const TAB_SEARCH_PARAM = 'tab';

// not in use
// const TeamPerformanceReviewWidget = dynamic(
//   () =>
//     import(
//       /* webpackChunkName: "team-activities-table-widget" */ '@/modules/learner/views/TeamDashboard/widgets/TeamPerformanceReviewWidget'
//     ),
// );

const TeamContentsTableWidget = dynamic(
  () =>
    import(
      /* webpackChunkName: "team-contents-table-widget" */ '@/modules/learner/views/TeamDashboard/widgets/TeamContentsTableWidget'
    ),
);
const TeamSessionsTableWidget = dynamic(
  () =>
    import(
      /* webpackChunkName: "team-sessions-table-widget" */ '@/modules/learner/views/TeamDashboard/widgets/TeamSessionsTableWidget'
    ),
);
const OneOnOnesTableWidget = dynamic(
  () =>
    import(
      /* webpackChunkName: "one-on-one-table-widget" */ '@/modules/learner/views/TeamDashboard/widgets/TeamOneOnOneTableWidget'
    ),
);

const TeamMgsaComponent = dynamic(
  () =>
    import(
      /* webpackChunkName: "team-mgsa-table-widget" */ '@/modules/learner/views/TeamDashboard/widgets/TeamMgsaWidget'
    ),
);

const TeamOverviewTableWidget = dynamic(
  () =>
    import(
      /* webpackChunkName: "team-learners-table-widget" */ '@/modules/learner/views/TeamDashboard/widgets/TeamLearnersTableWidget'
    ),
);

export enum TeamDashboardTabsEnum {
  Mgsa = 'mgsa',
  Content = 'content',
  Sessions = 'sessions',
  OneOnOne = 'oneOnOne',
  Overview = 'overview',
}

export const TEAM_DASHBOARD_TABS_CONFIG = {
  [TeamDashboardTabsEnum.Mgsa]: {
    key: TeamDashboardTabsEnum.Mgsa,
    labelKey: 'LearnerProfile:MGSA.MGSA',
    Component: TeamMgsaComponent,
    EmptyState: {
      Icon: PeopleOutline,
      titleKey: 'LearnerProfile:Learners.NoLearners',
      descriptionKey: 'LearnerProfile:Learners.NoLearnersTeamDescription',
    },
  },
  [TeamDashboardTabsEnum.Overview]: {
    key: TeamDashboardTabsEnum.Overview,
    labelKey: 'LearnerProfile:Reportees',
    Component: TeamOverviewTableWidget,
    EmptyState: {
      Icon: PeopleOutline,
      titleKey: 'LearnerProfile:Learners.NoLearners',
      descriptionKey: 'LearnerProfile:Learners.NoLearnersTeamDescription',
    },
  },
  [TeamDashboardTabsEnum.Content]: {
    key: TeamDashboardTabsEnum.Content,
    labelKey: 'LearnerProfile:Contents.Content',
    Component: TeamContentsTableWidget,
    EmptyState: {
      Icon: BookOpenOutline,
      titleKey: 'LearnerProfile:Contents.NoContent',
      descriptionKey: 'LearnerProfile:Contents.NoContentTeamDescription',
    },
  },
  [TeamDashboardTabsEnum.Sessions]: {
    key: TeamDashboardTabsEnum.Sessions,
    labelKey: 'Common:Sessions',
    Component: TeamSessionsTableWidget,
    EmptyState: {
      Icon: TvOutline,
      titleKey: 'LearnerProfile:Sessions.NoSessions',
      descriptionKey: 'LearnerProfile:Sessions.NoSessionsTeamDescription',
    },
  },
  [TeamDashboardTabsEnum.OneOnOne]: {
    key: TeamDashboardTabsEnum.OneOnOne,
    labelKey: 'Common:Routes.1on1',
    Component: OneOnOnesTableWidget,
    EmptyState: {
      Icon: MessageSquare2Outline,
      titleKey: 'LearnerProfile:OneOnOne.NoOneOnOne',
      descriptionKey: 'LearnerProfile:OneOnOne.NoOneOnOneDescription',
    },
  },
};

export const getTeamEntityEmptyState = (t: TFunction, tab: TeamDashboardTabsEnum) => {
  const { Icon, titleKey, descriptionKey } = TEAM_DASHBOARD_TABS_CONFIG[tab].EmptyState;

  return {
    Icon,
    title: t(titleKey),
    description: t(descriptionKey),
  };
};

export const getTeamDashboardTabs = ({
  t,
  getTeamDashboardTabEnabled,
  getTeamDashboardTabRoutes,
}: {
  t: TFunction;
  getTeamDashboardTabEnabled: (tab: TeamDashboardTabsEnum) => boolean;
  getTeamDashboardTabRoutes: (tab: TeamDashboardTabsEnum) => string;
}): TabType<TeamDashboardTabsEnum>[] =>
  getEnabledItems(
    Object.values(TEAM_DASHBOARD_TABS_CONFIG).map(({ labelKey, key }) => ({
      value: key,
      label: t(labelKey),
      to: getTeamDashboardTabRoutes(key),
      enabled: getTeamDashboardTabEnabled(key),
    })),
  );
